import { CSSProperties } from "react";

export const arrayIntersect = (
  array1: Array<string | number>,
  array2: Array<string | number>
): Array<string | number> => array1.filter(item => array2.includes(item));

export const hasBackgroundImage = (
  pathname: string,
  theme: string
): CSSProperties | undefined => {
  const hasBG = [
    "home",
    "about",
    "complete-profile",
    "download",
    "appfeedback",
    "maintenance-mode"
  ];
  const routeParts = pathname.split("/").filter((r: string) => !!r);

  let backgroundStyle;
  if (hasBG.some(item => routeParts.includes(item))) {
    const background = `/img/home-background-${theme}.jpg`;
    backgroundStyle = {
      marginTop: 0,
      backgroundImage: `url(${background})`,
      backgroundSize: "cover",
      backgroundPosition: "center center"
    };
  }

  return backgroundStyle;
};
